import React, {useEffect, useState} from 'react';
import {Layout} from 'antd';

import sanitizeHtml from 'utils/sanitizeHtml';
import apiClient from 'utils/apiClient';
import DefaultLayout from 'components/DefaultLayout';
import {useLocaleContext} from 'context/LocaleContext';

const {Content} = Layout;

const TermsTab: React.FC = () => {
    const {locale} = useLocaleContext();
    const [terms, setTerms] = useState<string>('');

    useEffect(() => {
        const loadTerms = async () => {
            try {
                const response = await apiClient.request(`/api/v1/terms-and-conditions/${locale}`, [], 'GET');
                // terms is null when the terms_policy table has no row for this language
                setTerms(response?.terms?.text ?? '');
            } catch (error) {
                console.error(error);
            }
        };

        loadTerms();
    }, [locale]);

    return (
        <>
            <hr className='form-group-separator'/>
            <Content className='terms-conditions-content'>
                <DefaultLayout.PageContent>
                    <div style={{fontSize: 16}} dangerouslySetInnerHTML={{__html: sanitizeHtml(terms)}}></div>
                </DefaultLayout.PageContent>
            </Content>
        </>
    );
};

export default TermsTab;
